import React,{useState} from 'react'
import { NavLink } from 'react-router-dom'
import AfterLoginTopbar from '../header/AfterLoginTopbar'
import CompletedDelivery from './CompletedDelivery';
import CurrentDelivery from './CurrentDelivery';
import UpcomingDelivery from './UpcomingDelivery';

const DeliveryList = () => {

    const [activeTab, setActiveTab] = useState("tabs-one");

    const HandleCurrent = () =>{
        setActiveTab("tabs-one")
    }
    const HandleUpcoming = () =>{
        setActiveTab("tabs-two")
    }
    const HandleComplete = () =>{
        setActiveTab("tabs-three")
    }


  return (
    <>
    <AfterLoginTopbar
    title="Delivery History"
    acttion="menu"
    />
    <div className='custom-tabs'>
        <ul>
            <li><button className={activeTab === "tabs-one" ? "active" : ""} onClick={HandleCurrent}>Current</button></li>
            <li><button className={activeTab === "tabs-two" ? "active" : ""} onClick={HandleUpcoming}>Upcoming</button></li>
            <li><button className={activeTab === "tabs-three" ? "active" : ""} onClick={HandleComplete}>Completed</button></li>
        </ul>
    </div>
    <div className='comon-body'>
        <div className='custom-tabs-content'>
            {activeTab === "tabs-one" && 
                <CurrentDelivery/>
            }
            {activeTab === "tabs-two" && 
                  <UpcomingDelivery/>
            }
            {activeTab === "tabs-three" && 
                  <CompletedDelivery/>
            }
           
        </div>
       
       
    </div>
  </>
  )
}

export default DeliveryList